
// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";   // ✅ ADDED
// import "./servicesstyle.css";
// import ServiceDetails from "./ServiceDetails/ServiceDetails";

// const Services = () => {
//   const [services, setServices] = useState([]);
//   const [active, setActive] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const location = useLocation(); // ✅ ADDED

//   // ✅ LOAD ALL SERVICES
//   useEffect(() => {
//     fetch("https://agepcoatings.com/getecaservices")
//       .then(res => res.json())
//       .then(data => {
//         setServices(data);

//         // ✅ AUTO-OPEN IF LANDING PASSED ID
//         if (location.state?.activeId) {
//           openDetailsById(location.state.activeId);
//         }
//       });
//   }, [location.state]);

//   // ✅ LOAD SINGLE SERVICE BY ID (ON CARD CLICK OR REDIRECT)
//   const openDetailsById = async (id) => {
//     try {
//       setLoading(true);
//       const res = await fetch(`https://agepcoatings.com/getecaservices/${id}`);
//       const data = await res.json();
//       setActive(data);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="container services-wrapper">
//       <h2 className="services-title fw-bold">Services</h2>

//       {/* ✅ TOP GRID */}
//       <div className="services-grid">
//         {services.map(item => (
//           <div
//             key={item._id}
//             className={`services-card ${
//               active?._id === item._id ? "active" : ""
//             }`}
//             onClick={() => openDetailsById(item._id)}
//           >
//             <img src={item.servicesGrid.image} alt="" />
//             <div className="services-overlay">
//               <span>{item.servicesGrid.title}</span>
//               <button className="services-hover-btn">
//                 Learn More
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ✅ LOADING */}
//       {loading && <p style={{ marginTop: 30 }}>Loading details...</p>}

//       {/* ✅ FULL DETAILS */}
//       {!loading && active && <ServiceDetails active={active} />}
//     </section>
//   );
// };

// export default Services;

import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./servicesstyle.css";
import ServiceDetails from "./ServiceDetails/ServiceDetails";

const Services = () => {
  const [services, setServices] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const detailsRef = useRef(null); // ✅ FOR AUTO SCROLL

  // ✅ LOAD ALL SERVICES
  useEffect(() => {
    fetch("https://agepcoatings.com/getecaservices")
      .then(res => res.json())
      .then(data => {
        setServices(data);

        // ✅ AUTO-OPEN IF LANDING PASSED ID
        if (location.state?.activeId) {
          openDetailsById(location.state.activeId);
        }
      });
  }, [location.state]);

  // ✅ LOAD SINGLE SERVICE BY ID (ON CARD CLICK OR REDIRECT)
  const openDetailsById = async (id) => {
    try {
      setLoading(true);
      const res = await fetch(`https://agepcoatings.com/getecaservices/${id}`);
      const data = await res.json();
      setActive(data);

      // ✅ AUTO SCROLL AFTER DATA LOAD
      setTimeout(() => {
        detailsRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 150);

    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container services-wrapper">
      <h2 className="services-title fw-bold">Services</h2>

      {/* ✅ TOP GRID */}
      <div className="services-grid">
        {services.map(item => (
          <div
            key={item._id}
            className={`services-card ${
              active?._id === item._id ? "active" : ""
            }`}
            onClick={() => openDetailsById(item._id)}
          >
            <img src={item.servicesGrid.image} alt="" />
            <div className="services-overlay">
              <span>{item.servicesGrid.title}</span>
              <button className="services-hover-btn">
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ LOADING */}
      {loading && <p style={{ marginTop: 30 }}>Loading details...</p>}

      {/* ✅ FULL DETAILS + SCROLL TARGET */}
      {!loading && active && (
        <div ref={detailsRef}>
          <ServiceDetails active={active} />
        </div>
      )}
    </section>
  );
};

export default Services;
